import React from 'react'
import { Link } from 'react-router-dom'

const Map = () => {
  return (
    <section className="map-section">
    <div className="auto-container">
      <div className="row clearfix">
        <div className="contact-column col-lg-5 col-md-12 col-sm-12 order-2">
          <div className="inner-column">
            <div className="sec-title">
              <span className="sub-title">QUICK CONTACT</span>
              <h2>Need Help? Contact Us</h2>
              <span className="divider" />
              <div className="text">
                Available to our business customers 24 hours a day.
              </div>
            </div>
            <ul className="contact-info">
              <li>
                <span className="icon fa fa-map-marker-alt" />
                <h4>Our Location:</h4>
                <p>27 Division St, New York, NY 10002, United States.</p>
              </li>
              <li>
                <span className="icon fa fa-phone-volume" />
                <h4>24/7 Hotline:</h4>
                <p>+8 (123) 985 789, +8 (123) 985 535</p>
              </li>
              <li>
                <span className="icon fa fa-envelope" />
                <h4>Email:</h4>
                <p>
                  <Link  to="mailto:newyork@example.com">CPC75.newyork@gmail.com</Link>
                </p>
              </li>
            </ul>
          </div>
        </div>
        {/* Form Column */}
        <div className="map-column col-lg-7 col-md-12 col-sm-12">
          {/*Map Outer*/}
          {/* <div className="map-outer-dev">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d805184.6331292129!2d144.49266890254142!3d-37.97123689954809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad646b5d2ba4df7%3A0x4045675218ccd90!2sMelbourne%20VIC%2C%20Australia!5e0!3m2!1sen!2s!4v1574408946759!5m2!1sen!2s"
              allowFullScreen=""
            />
          </div> */}
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default Map